// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"43b9b239","605":"549007c7","809":"62452d41","981":"8e0f9c51"}[chunkId] + ".chunk.js";
};